
import { useEffect, useState } from 'react';
import { setSocketInstance } from "./globals";


const WebSocketClient = ({ url, onReceiveData }) => {

  useEffect(() => {
    const websocket = new WebSocket(url);
    setSocketInstance(websocket)
    websocket.onmessage = (event) => {
      if (event.data instanceof Blob) {
        event.data.text().then((jsonData) => {
          try {
            const parsedData = JSON.parse(jsonData);
            onReceiveData(parsedData);
          } catch (error) {
            console.error("Error parsing JSON:", error);
          }
        });
      } else {
        console.log("Received message");
      }
    };

    websocket.onopen = () => {
      console.log('WebSocket connected');
    };

    websocket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    websocket.onclose = () => {
      console.log('WebSocket closed');
    };

    return () => {
      websocket.close();
    };
  }, [url]);

  return null;
};

export default WebSocketClient;